import React, { FC } from 'react';
import { Typography, FormHelperText } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import dayjs from 'dayjs';
import { ptBR } from 'date-fns/locale';
import clsx from 'clsx';
import { stylesCalculator } from '../../styles/calculator';

interface CalculatorProps {
    beginDate: Date | null;
    beginJob: Date | null;
    errorMessageBeginDate: string;
    errorMessageBeginJob: string;
    handleBeginDateChange: (date: Date | null) => void;
    handleChangeBeginJob: (date: Date | null) => void;
}

const JobInfoInput: FC<CalculatorProps> = (props: CalculatorProps) => {
    const classes = stylesCalculator();
    const {
        beginDate,
        beginJob,
        errorMessageBeginDate,
        errorMessageBeginJob,
        handleBeginDateChange,
        handleChangeBeginJob,
    } = props;
    const today = new Date();
    const minDate = new Date(today.getFullYear() - 120, today.getMonth(), today.getDay());
    return (
        <div className={classes.container}>
            <Typography className={classes.title} variant="h4" component="p">
                Datas
            </Typography>
            <Typography
                className={clsx( classes.subtitle)}
                align={'center'}
                variant="h6"
                component="p"
            >
                Data de inicio no serviço público
            </Typography>
            <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                <KeyboardDatePicker
                    className={clsx(classes.calendarInput)}
                    margin="none"
                    format="dd/MM/yyyy"
                    value={beginDate}
                    onChange={handleBeginDateChange}
                    invalidDateMessage="Data em formato inválido."
                    minDate={minDate}
                    minDateMessage={`A data deve ser maior que ${dayjs(minDate).format('DD/MM/YYYY')}.`}
                    cancelLabel="Cancelar"
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                />
            </MuiPickersUtilsProvider>
            <FormHelperText className={clsx(errorMessageBeginDate === '' && classes.hide, classes.errorText)}>
                {errorMessageBeginDate}
            </FormHelperText>
            <Typography className={classes.subtitle} align={'center'} variant="h6" component="p">
                Data de inicio no último cargo
            </Typography>
            <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                <KeyboardDatePicker
                    className={classes.calendarInput}
                    margin="none"
                    format="dd/MM/yyyy"
                    value={beginJob}
                    onChange={handleChangeBeginJob}
                    invalidDateMessage="Data em formato inválido."
                    minDate={minDate}
                    minDateMessage={`A data deve ser maior que ${dayjs(minDate).format('DD/MM/YYYY')}.`}
                    cancelLabel="Cancelar"
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                />
            </MuiPickersUtilsProvider>
            <FormHelperText className={clsx(errorMessageBeginJob === '' && classes.hide, classes.errorText)}>
                {errorMessageBeginJob}
            </FormHelperText>
        </div>
    );
};

export default JobInfoInput;
